import posthog from "posthog-js";
class Limy {
    token;
    isInitialized = false;
    constructor() {
        this.token = "";
    }
    // initiate with token
    async initiate(token) {
        if (this.isInitialized) {
            return;
        }
        this.token = token;
        try {
            const el = document.getElementsByTagName("html")[0];
            if (el) {
                if (!el.style.backgroundColor) {
                    el.style.background = "white";
                }
            }
        }
        catch (e) { }
        try {
            posthog.init(this.token, {
                api_host: "https://analytics.getlimy.ai",
                capture_pageview: true,
                autocapture: false,
                persistence: "localStorage+cookie",
                token: this.token,
                advanced_disable_feature_flags_on_first_load: true,
                advanced_disable_feature_flags: true,
            });
            this.isInitialized = true;
        }
        catch (e) {
            console.error("Limy: Error initializing", e);
        }
    }
    // capture page view
    page() {
        console.log("Limy: Page view tracked");
        if (!this.isInitialized) {
            console.warn("Limy: Call initiate() before tracking events");
            return;
        }
        try {
            posthog.capture("$pageview");
            console.log("Limy: Page view tracked");
        }
        catch (e) {
            console.error("Limy: Error tracking page view", e);
        }
    }
    // track custom events
    track(eventName, properties) {
        if (!this.isInitialized) {
            console.warn("Limy: Call initiate() before tracking events");
            return;
        }
        try {
            posthog.capture(eventName, properties);
            console.log("Limy: Event tracked:", eventName, properties);
        }
        catch (e) {
            console.error("Limy: Error tracking event", e);
        }
    }
    // identify user
    identify(userId, properties) {
        if (!this.isInitialized) {
            console.warn("Limy: Call initiate() before identifying users");
            return;
        }
        try {
            posthog.identify(userId, properties);
            console.log("Limy: User identified:", userId, properties);
        }
        catch (e) {
            console.error("Limy: Error identifying user", e);
        }
    }
    // set user properties
    setPersonProperties(properties) {
        if (!this.isInitialized) {
            console.warn("Limy: Call initiate() before setting properties");
            return;
        }
        try {
            posthog.setPersonProperties(properties);
            console.log("Limy: Person properties set:", properties);
        }
        catch (e) {
            console.error("Limy: Error setting person properties", e);
        }
    }
    // reset user
    reset() {
        if (!this.isInitialized) {
            console.warn("Limy: Call initiate() before resetting");
            return;
        }
        try {
            posthog.reset();
            console.log("Limy: User reset");
        }
        catch (e) {
            console.error("Limy: Error resetting user", e);
        }
    }
}
// Global instance
const limyInstance = new Limy();
// Global function that processes commands
function limy(command, ...args) {
    switch (command) {
        case "initiate":
            return limyInstance.initiate(args[0]);
        case "page":
            return limyInstance.page();
        case "track":
            return limyInstance.track(args[0], args[1]);
        case "identify":
            return limyInstance.identify(args[0], args[1]);
        case "setPersonProperties":
            return limyInstance.setPersonProperties(args[0]);
        case "reset":
            return limyInstance.reset();
        default:
            console.warn("Limy: Unknown command:", command);
    }
}
// Process any queued calls
if (typeof window !== "undefined") {
    // Get the queued calls
    const queue = window.limy?.q || [];
    window.limy = limy;
    // Check if there's a token in the script tag
    const scriptTag = document.getElementById("limy-analytics");
    const token = scriptTag?.getAttribute("limy");
    if (token) {
        // Auto-initialize with the token
        queue.unshift(["initiate", token]);
    }
    // Process all queued calls
    queue.forEach((args) => {
        try {
            limy.apply(null, args);
        }
        catch (e) {
            console.error("Limy: Error processing queued call", args, e);
        }
    });
}
// Export for module usage
export default limy;
export { Limy, limyInstance };
